var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.login)?_c('Top'):_c('FrontHeader'),_c('v-main',{staticClass:"grey lighten-3"},[_c('Info'),(_vm.login)?_c('Drawer'):_vm._e(),_c('router-view')],1),(_vm.login)?_c('Footer'):_c('FrontFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }